(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.getAttribute('data-ready')) return;
      root.setAttribute('data-ready', '1');
      var slides = root.querySelectorAll('.fj-hero__slide');
      var tabs = root.querySelectorAll('.fj-hero__tab');
      if (slides.length < 2) return;
      var current = 0;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
        tabs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === current);
          if (n === current) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }

      tabs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });

      // Når stregen under den aktive fane er fyldt op, skifter vi til næste slide
      root.addEventListener('animationend', function (e) {
        if (e.animationName === 'fj-hero-fill') show(current + 1);
      });

      // Swipe på mobil
      var startX = null;
      root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
      });

      // Vis det valgte slide i temaeditoren
      root.addEventListener('shopify:block:select', function (e) {
        var idx = Array.prototype.indexOf.call(slides, e.target);
        if (idx > -1) show(idx);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-fj-hero]').forEach(init);
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(bar) {
      var track = bar.querySelector('.scrolling-bar__track');
      if (!track) return;
      var groups = track.querySelectorAll('.scrolling-bar__group');
      if (groups.length < 2) return;
      bar.querySelectorAll('[data-clone]').forEach(function (el) { el.remove(); });
      var groupWidth = groups[0].getBoundingClientRect().width;
      if (!groupWidth) return;
      var copies = Math.ceil(bar.clientWidth / groupWidth);
      if (copies > 1) {
        groups.forEach(function (group) {
          var items = Array.prototype.slice.call(group.children);
          for (var c = 1; c < copies; c++) {
            items.forEach(function (item) {
              var clone = item.cloneNode(true);
              clone.setAttribute('data-clone', '');
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('data-shopify-editor-block');
              clone.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
              group.appendChild(clone);
            });
          }
        });
      }
      var speed = parseFloat(bar.getAttribute('data-speed')) || 50;
      var finalWidth = groups[0].getBoundingClientRect().width;
      bar.style.setProperty('--bar-duration', (finalWidth / speed).toFixed(2) + 's');
    }
    function initAll(root) {
      (root || document).querySelectorAll('[data-scrolling-bar]').forEach(setup);
    }
    var resizeTimer, lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { initAll(); }, 200);
    });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    function start() {
      initAll();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { initAll(); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();
})();
